import {Routes} from '@angular/router';
import {angLiebCoreAuthenticatedGuard} from "@liebink/ang-lieb-core";

export const routes: Routes = [
    {
        loadComponent: () => import('./components/app-welcome.component').then(result => result.AppWelcomeComponent),
        canActivate: [angLiebCoreAuthenticatedGuard],
        path: '',
    },
    {
        loadChildren: () => import('../identity/identity.routes').then(m => m.routes),
        canActivate: [angLiebCoreAuthenticatedGuard],
        path: 'identity',
    },
    {
        loadChildren: () => import('../mailer/mailer.routes').then(m => m.routes),
        canActivate: [angLiebCoreAuthenticatedGuard],
        path: 'mailer',
    },
    {
        loadChildren: () => import('../platform/platform.routes').then(m => m.routes),
        canActivate: [angLiebCoreAuthenticatedGuard],
        path: 'platform',
    },
    {
        loadChildren: () => import('../product/product.routes').then(m => m.routes),
        canActivate: [angLiebCoreAuthenticatedGuard],
        path: 'product',
    },
    {
        loadChildren: () => import('../support/support.routes').then(m => m.routes),
        canActivate: [angLiebCoreAuthenticatedGuard],
        path: 'support',
    },
    {
        loadChildren: () => import('../me/me.routes').then(m => m.routes),
        path: 'me',
    },
];
